import linkViewModel from '@vimcar/mvvm/linkViewModel'
import IForm from '@vimcar/shared-components/components/IForm/'
import TextField from '@vimcar/shared-components/components/IForm/components/TextField'
import Paragraph from '@vimcar/shared-components/components/Paragraph'
import * as React from 'react'

import type { ViewModel } from './viewModel'

import i18n from '../../utils/i18n'
import i18nx from '../../utils/i18n'
import styles from './styles.css'
import mkViewModel from './viewModel'

const tp = i18n.prefixWithoutTestId('SearchField')

type Props = {
  viewModel: ViewModel
}

const SearchField = ({ viewModel }: Props) => (
  <React.Fragment>
    {/* @ts-expect-error@2322 */}
    <IForm onChange={viewModel.handleSearchFormChange}>
      <TextField
        className={styles.searchField}
        // @ts-expect-error@2322
        clearable
        label={i18nx.t('global.search')}
        optional
        property='term'
      />
    </IForm>
    {viewModel.links.length > 0 && (
      <Paragraph className={styles.defaultWeight} variant='subtitle2'>
        {tp('relevant-links')}
      </Paragraph>
    )}
    {viewModel.links.map((link, index) => (
      <Paragraph
        className={styles.link}
        component='a'
        key={index}
        // @ts-expect-error@2339
        onClick={viewModel.handleLinkClick(link)}
        variant='body1'
      >
        {link.text}
      </Paragraph>
    ))}
    {viewModel.links.length > 0 && (
      <Paragraph className={styles.resultsTitle} variant='subtitle2'>
        {tp('search-results')}
      </Paragraph>
    )}
  </React.Fragment>
)

const component = linkViewModel(mkViewModel, SearchField)
component.displayName = 'SearchField'
export default component
